import React from 'react'
import { Form, AutoComplete, Input } from 'antd'
import classnames from 'classnames'
import { LABEL_ALIGN_TYPE } from '../form.constants'
import { formRules, Validator } from '../form.utils'
import '../form.scss'
import InfoToolTipLabel from '../infotooltip-label/infotooltip-label'

export interface OptionProp {
  key: string
  value: string
  label?: string
  displayName?: string
  email?: string
  title?: string
  office?: string
}

export interface AutoCompleteInputProps {
  htmlLabel?: string | any
  label?: string | any
  name?: string | any
  isRequired?: boolean
  labelAlign?: keyof typeof LABEL_ALIGN_TYPE
  onChange?: (value: string) => void
  className?: string
  inputContainerStyle?: string
  validateTrigger?: string | string[]
  validator?: Validator
  prefix?: React.ReactNode
  placeholder?: string
  value?: string | null | undefined
  options?: OptionProp[] | []
  onSelect?: any
  ref?: any
  isDisabled?: boolean
  infoText?: string
}

const AutoCompleteInput: React.FC<AutoCompleteInputProps> = (
  props: AutoCompleteInputProps
) => {
  const {
    htmlLabel,
    label,
    name,
    labelAlign,
    isRequired,
    validator,
    className,
    validateTrigger,
    prefix,
    value,
    inputContainerStyle,
    options,
    onChange,
    onSelect,
    ref,
    isDisabled,
    infoText,
  } = props

  return (
    <>
      <label htmlFor={htmlLabel ? htmlLabel : label}>
        <InfoToolTipLabel label={label} infoText={infoText} />
      </label>
      <Form.Item
        label={label}
        name={name}
        labelAlign={labelAlign}
        validateTrigger={validateTrigger}
        className={classnames('block', className)}
        rules={formRules(label, isRequired, validator)}
        validateFirst={true}
        getValueFromEvent={(value) => {
          // Clean the value before storing in form field
          return value && value.includes('|||') ? value.split('|||')[0] : value
        }}
      >
        <AutoComplete
          className={classnames('form-item-input-width', inputContainerStyle)}
          value={value && value.includes('|||') ? value.split('|||')[0] : value}
          options={options?.map((opt) => ({
            key: opt.key,
            value: opt.value,
            displayName: opt.displayName,
            label: (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontWeight: 'bold' }}>
                  {opt.displayName || opt.label || opt.value}
                </span>
                {opt.email && (
                  <span style={{ fontSize: '12px', color: '#666' }}>
                    {opt.email}
                  </span>
                )}
                {opt.title && (
                  <span style={{ fontSize: '11px', color: '#999' }}>
                    {opt.title}
                  </span>
                )}
              </div>
            ),
          }))}
          filterOption={false}
          onChange={(value) => {
            // Clean the value before passing to parent onChange
            const cleanValue =
              value && value.includes('|||') ? value.split('|||')[0] : value
            onChange?.(cleanValue)
          }}
          aria-label={label}
          onSelect={(selectedValue, option) => {
            // Extract just the display name from the unique value
            const cleanName =
              (option as any).displayName ||
              (selectedValue.includes('|||')
                ? selectedValue.split('|||')[0]
                : selectedValue)
            // Call the parent's onSelect with clean name instead of the unique value
            onSelect?.(cleanName, option)
          }}
          disabled={isDisabled}
        >
          <Input
            aria-label={label}
            disabled={false}
            id={name}
            prefix={prefix}
            type="text"
            ref={ref}
          />
        </AutoComplete>
      </Form.Item>
    </>
  )
}

export default AutoCompleteInput
